import { useSelector } from 'react-redux'

import PromoCode from '@/components/PromoCode'
import { paymentRegisterTotalSelector } from '@/selectors'
import { translate } from '@/utils/translations'

import PromoCodeDiscount from './PromoCodeDiscount'
import Taxes from './Taxes'
import TaxExemptionLink from './TaxExemptionLink'
import VatTaxMessage from './VatTaxMessage'

const PaymentRegister = () => {
  const subTotal = useSelector(
    state => state.cart.formattedSubTotalBeforeDiscountOrTax
  )
  const total = useSelector(paymentRegisterTotalSelector)
  const storeCurrency = useSelector(state => state.currentRegion.storeCurrency)
  const isPromoCodeEnabled = useSelector(
    state => state.checkout.isPromoCodeEnabled
  )

  return (
    <div className='price-list__order-details'>
      <If condition={isPromoCodeEnabled}>
        <PromoCode />
      </If>

      <ul className='order-product-divider'>
        <li>
          {translate('common.subtotal_label')}{`:`}
          <span className='qa-price-subtotal u-float--right'>
            {subTotal}
          </span>
        </li>
        <If condition={isPromoCodeEnabled}>
          <PromoCodeDiscount />
        </If>
        <Taxes />
        <TaxExemptionLink />
      </ul>
      <div className='styled_as_body_font u-weight--bold clearfix'>
        {translate('common.order_total_label')}{`: `}
        <span className='u-float--right qa-price-total'>
          {total}
          {' '}
          {storeCurrency}
        </span>
      </div>
      <VatTaxMessage />
    </div>
  )
}

export default PaymentRegister
